export  const initialData = [
    //19.02.2026
    {
        fullName: 'Abdurazakov Rustam Kayumov',
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000018',
        url: 'https://test.tdtu.uz/storage/pages/February2026/xFiAKAC362XmKVi2LBS2.pdf'
    },
    {
        fullName: "Samadov Mirshoxid Miroqil o'g'li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000019',
        url: 'https://test.tdtu.uz/storage/pages/February2026/kga7wRtgYuNCramaCLGw.pdf'
    },
    {
        fullName: "Samatov Mirakbar Mirakilovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000020',
        url: 'https://test.tdtu.uz/storage/pages/February2026/FJHrEUrEyfJ2VIXkpOmS.pdf'
    },
    {
        fullName: 'Mustafoyev Azizjon Olimjonovich',
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000021',
        url: 'https://test.tdtu.uz/storage/pages/February2026/CQW4P8s5iuW0cbiqabz3.pdf'
    },
    {
        fullName: 'Jabborov Dilshod Muxtorovich',
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000022',
        url: 'https://test.tdtu.uz/storage/pages/February2026/tZoYJlXBlx4P3j2cl0dR.pdf'
    },
    {
        fullName: "Abdullabekova Dilafruz Rustamjon qizi",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000023',
        url: 'https://test.tdtu.uz/storage/pages/February2026/mN8POlc5AYFXFL5D4DCz.pdf'
    },
    {
        fullName: "Shukurullayev Sarvar Anvar o'g'li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000024',
        url: 'https://test.tdtu.uz/storage/pages/February2026/XIUGX80AWcCbbpplkdOL.pdf'
    },
    {
        fullName: "Vahabov Azizbek Toxir o'g'li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000025',
        url: 'https://test.tdtu.uz/storage/pages/February2026/WyiMsWcCaGD7QjKMvr0n.pdf'
    },
    {
        fullName: "Xaitmuradov Bobir Olimovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000026',
        url: 'https://test.tdtu.uz/storage/pages/February2026/Fsxh0rtikdjbwYDXjrAv.pdf'
    },
    {
        fullName: "Yaqubov Zafarjon Xakimovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000027',
        url: 'https://test.tdtu.uz/storage/pages/February2026/bSeByM8JO12sZIqcc1Co.pdf'
    },
    {
        fullName: "Axmedov Ahmad Maxmudjonovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000028',
        url: 'https://test.tdtu.uz/storage/pages/February2026/SfWP8h9eKfAH4Wdg8yzO.pdf'
    },
    {
        fullName: "Unarov Abdurauf Norbayevich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000029',
        url: 'https://test.tdtu.uz/storage/pages/February2026/Bhz11jqz8nA9YmeBPEKM.pdf'
    },
    {
        fullName: "Xolmuminov Shaxboz Ravshan o'g'li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000030',
        url: 'https://test.tdtu.uz/storage/pages/February2026/mGnz1ZAmXnF09bfKtbW5.pdf'
    },
    {
        fullName: "Xalilov Sherzodbek Alijonovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000031',
        url: 'https://test.tdtu.uz/storage/pages/February2026/ViSaRsRYMDsbwHU3SSFd.pdf'
    },
    {
        fullName: "Badalova Dildora Abdumalikovna",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000032',
        url: 'https://test.tdtu.uz/storage/pages/February2026/4li6GPNfBdk6SxXg2IXR.pdf'
    },
   //05.03.2026
    {
        fullName: "Kurbonov Orifxon Obidovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000033',
        url: 'https://test.tdtu.uz/storage/pages/March2026/2ybDodpw8NQmeq0kVptE.pdf'
    },
    {
        fullName: "Samoylenko Mixaylo Yuriyovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000034',
        url: 'https://test.tdtu.uz/storage/pages/March2026/3rNKsXIjIkXWtgz9FbmI.pdf'
    },
    {
        fullName: "Jalolov Shaxzod Raim o'g'li",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000035',
        url: 'https://test.tdtu.uz/storage/pages/March2026/Jb2jqjRubZ2rpNVVqjEK.pdf'
    },
    {
        fullName: "Jumamuratov Kunxoja Mirzamurat uli",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000036',
        url: 'https://test.tdtu.uz/storage/pages/March2026/60pf6K4Eb34MR50l0Oer.pdf'
    },
    {
        fullName: "Orazimbetov Baburbek Ramatulla uli",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000037',
        url: 'https://test.tdtu.uz/storage/pages/March2026/CjRtmoDZXa0Wvw4LyyMA.pdf'
    },
    {
        fullName: "Kozlenko Andrey Vladimirovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000038',
        url: 'https://test.tdtu.uz/storage/pages/March2026/ExGVozKMogr4TShCAdJt.pdf'
    },
    {
        fullName: "Perova Yelizaveta Andreyevna",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000039',
        url: 'https://test.tdtu.uz/storage/pages/March2026/lSez4fvtnfafCMiBbIpc.pdf'
    },
    {
        fullName: "Prokudina Kristina Aleksandrovna",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000040',
        url: 'https://test.tdtu.uz/storage/pages/March2026/c6leYypf5zqOfJSF4Kzm.pdf'
    },
    {
        fullName: "Otamurodov Sardor Ilxomovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000041',
        url: 'https://test.tdtu.uz/storage/pages/March2026/UoJfqULO3sQBzFZPD9gX.pdf'
    },
    {
        fullName: "Uzoqov Husan Zokirovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000042',
        url: 'https://test.tdtu.uz/storage/pages/March2026/VnMCBmHkMV7sbDLtN7Uk.pdf'
    },
    {
        fullName: "Yakubov Abrar Tulkunovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000043',
        url: 'https://test.tdtu.uz/storage/pages/March2026/BlAJb4y0eCuNX9PfL9Ej.pdf'
    },
    {
        fullName: "Norimov Sherali Komilovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000044',
        url: 'https://test.tdtu.uz/storage/pages/March2026/8hBrqN0yi0SP9XIP4qBq.pdf'
    },
    {
        fullName: "Eshdavlatov Utkir Norboboyevich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000045',
        url: 'https://test.tdtu.uz/storage/pages/March2026/vh8qTvXA130m1RJcock7.pdf'
    },
    {
        fullName: "Masharipov Ilhomboy Ikrom o'g'li",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000046',
        url: 'https://test.tdtu.uz/storage/pages/March2026/dISv5dhn46ceDNRHm7al.pdf'
    },
    {
        fullName: "Urinov Abror Botirovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000047',
        url: 'https://test.tdtu.uz/storage/pages/March2026/oEEtElMK69ZLRQrxVmBN.pdf'
    },
    {
        fullName: "Nimatullayev Zafar Sunatullayevich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000048',
        url: 'https://test.tdtu.uz/storage/pages/March2026/iUYmFQdJtICSvp0pHYTN.pdf'
    },
    {
        fullName: "Nimatullayev Sarvar Sunatullayevich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000049',
        url: 'https://test.tdtu.uz/storage/pages/March2026/PAefQot5LOrSHKyEUxg5.pdf'
    },
    {
        fullName: "Nabiyev Uygun Muradaliyevich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000050',
        url: 'https://test.tdtu.uz/storage/pages/March2026/NH3OPFqlZKguvZ0vzZya.pdf'
    },
    {
        fullName: "Muxtarov Odilxon Arslanovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000051',
        url: 'https://test.tdtu.uz/storage/pages/March2026/Cj3LGthZBlUMd6m2Kmo1.pdf'
    },
    {
        fullName: "Qozixonov Madixon Tolibxon o'g'li",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000052',
        url: 'https://test.tdtu.uz/storage/pages/March2026/7IUCE5MbwknxYYY6TDDJ.pdf'
    },
    {
        fullName: "Jumaboyev Humayun Qahramonovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000017',
        url: 'https://test.tdtu.uz/storage/pages/March2026/dBuAsUwnqIrYiUJGd46k.pdf'
    },
];